


















import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class FaqCategories extends Vue {
    @Prop() categories!: number[];

    @Prop({ default: 50 }) perPage!: number;

    loading: boolean = false;

    params: any = { per_page: 50, page: 1 };

    faqs: any = [];

    async mounted() {
        this.params.per_page = this.perPage;

        if (this.categories) {
            const categoryIds = this.categories.map((c: any) => {
                return c.term_id;
            });
            for (const id of categoryIds) {
                await this.getFaq(id);
            }
        }
    }

    private async getFaq(category: number) {
        this.loading = true;

        // @ts-ignore
        return axios
            .get("/api/faq", { params: { ...this.params, faq_categories: [category] } })
            .then((response: any) => {
                this.faqs = this.faqs.concat(response.data.data);
            })
            .finally(() => (this.loading = false));
    }
    get computedCategories() {
        if (!this.categories) {
            return;
        }
        return this.categories.map((c: any) => {
            return {
                id: c.term_id,
                name: c.name,
                faqs: [
                    ...this.faqs
                        .filter((f: any) => {
                            return f.faq_categories.includes(c.term_id);
                        })
                        .reduce((a: any, c: any) => {
                            a.set(c.id, c);
                            return a;
                        }, new Map())
                        .values()
                ]
            };
        });
    }
}
